import React from "react";
import Button from "../../../../../components/Common/Button/Button";
import classes from "./ManageGroupFooter.module.scss";
import { FormattedMessage } from "react-intl";

const ManageGroupFooter = ({
  disabled,
  onCancelClick,
  onSubmitClick,
  loading,
}) => {
  return (
    <div className={classes.manageGroupFooter}>
      <div className={classes.cancelText} onClick={onCancelClick}>
        <FormattedMessage id="CANCEL_TEXT" />
      </div>
      <Button
        type="submit"
        label={<FormattedMessage id="P_SAVE_TXT" />}
        small
        dark
        onClick={onSubmitClick}
        backgroundColor={loading ? undefined : "#D31B61"}
        loading={loading}
        disabled={disabled}
      />
    </div>
  );
};

export default ManageGroupFooter;
